import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SearchComponent } from '../search/search.component';
import { ToggleSidebarCart } from '../../../../store/action/cart.action';
import { Store } from '@ngxs/store';
import { CartComponent } from '../cart/cart.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../../../widgets/modal/confirmation-modal/confirmation-modal.component';
import { AuthService } from '../../../../../core/services/api/auth.service';
import { APIResponseVM } from '../../../../../core/models/common/common.model';
import { ResponseCodeEnum } from '../../../../../core/enums/common.enum';
import { NotificationService } from '../../../../services/notification.service';
import { Logout } from '../../../../store/action/auth.action';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [RouterModule, TranslateModule, SearchComponent, CartComponent],
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss'
})
export class MobileMenuComponent {

  public active: string = '';
  logoutOption:boolean = false;

  constructor(
    private store: Store,
    private authService: AuthService, 
    private router: Router,
    private modal: NgbModal,
    private notificationService: NotificationService
  ){
    if (router.url.split('/').length > 1 && router.url.split('/')[1] !== '') {
      this.active=router.url.split('/')[1]; 
    }else if(router.url.split('/').length < 3){
      this.active=router.url; 
    }
    if (this.store.selectSnapshot(state => state.auth && state.auth.token)) {
      this.logoutOption = true;
    }

  }

  cartToggle(value: boolean) {
    // this.store.dispatch(new ToggleSidebarCart(value));
  }

  activeMenu(menu: string){
    this.active = menu
  }

  // reDirectWishlist(){
  //   if(!this.store.selectSnapshot(state => state.auth && state.auth.token)){
  //     // this.authService.isLogin = true;
  //   }
  //   else {
  //     this.router.navigate(['/wishlist'])
  //     this.activeMenu('wishlist')
  //   } 
  // }

  logout(){
    // const modal = this.modal.open(ConfirmationModalComponent, { centered: true, windowClass: '' });
    //     modal.componentInstance.confirm.subscribe((val: boolean) => {
    Swal.fire({
                  title: 'Are you sure?',
                  text: 'You want to logout?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes',
                  reverseButtons: true,
                  heightAuto: false,
              }).then((result) => {
                  if (result?.isConfirmed) {
                    this.authService.logout().subscribe({
                      next:(res:APIResponseVM<string>)=>{
                        if (res.responseCode === ResponseCodeEnum.SUCCESS) {
                          this.notificationService.showSuccess(res?.message)
                          this.store.dispatch(new Logout());
                          window.location.reload();
                        }       
                      },
                      error:(err)=>{console.log(err)}
                    });
                  }
              });
        // })
  }
  
}
